module.exports = __webpack_public_path__ + "static/img/scene-gpkl.7e5247c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/scene/scene-gpkl.png
// module id = Rbuu
// module chunks = 1